import * as React from "react";
import styled from "styled-components";
import {ISvgIconProps, SvgIcon} from '../../../basic-ui-components/icon/svg-icon/svg.icon';

export interface ITwoCharsIconProps extends ISvgIconProps {
    text: string;
}

const TextTag = styled.text`
    font-family: "888-Bold", Verdana, sans-serif;
    font-size: 15px;
    text-transform: uppercase;
    dominant-baseline: central;
`;

export class TwoCharsIcon extends React.Component<ITwoCharsIconProps, {}> {
    render() {
        let text = this.props.text.trim().substr(0,2);
        return (
            <SvgIcon {...this.props}>
                <g>
                    <TextTag
                        fill="currentColor"
                        x="50%" y="50%"
                        textAnchor="middle"
                    >{text}</TextTag>
                </g>
            </SvgIcon>
        );
    }
}
